/**
 * Sticky header tools.
 */
function sticky_header_tools() {
    /**
     * Margin between header and element when scrolling backwards to an element.
     */
    const scrollMargin = 24;

    /**
     * WordPress admin bar height in desktop.
     */
    const wordPressAdminBarHeightDesktop = 32;

    /**
     * How much an element can be outside the visible viewport before it is considered to be outside of it.
     */
    const errorMargin = 16;

    /**
     * Finds and returns all focusable children of the supplied parent element.
     *
     * @param {*} el A parent element
     * @returns Focusable children of the parent element
     */
    function getFocusableChildren(el) {
        if (!el) {
            return [];
        }
        return el.querySelectorAll([
            'input',
            'select',
            'a[href]',
            'textarea',
            'button',
            '[tabindex]',
        ]);
    }

    /**
     * Checks if the supplied element is visible and returns a representative boolean value.
     *
     * The element is considered visible if:
     * 1. It is inside the viewport (barring an error margin).
     * 2. It is not under the sticky header.
     *
     * @param {*} el The element to examine
     * @returns      `true` if the element is visible, `false` otherwise
     */
    function isElementVisible(el) {
        if (typeof window.header_tools === 'undefined') {
            // console.log('Header tools undefined');
            return;
        }

        let rect = el.getBoundingClientRect();
        const isVisible =
            rect.top >= window.header_tools.currentHeaderHeight &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) +
                    errorMargin;
        return isVisible;
    }

    /**
     * Scrolls the window so that the supplied element:
     *
     * 1. Is inside the viewport.
     * 2. Is not under the sticky header.
     *
     * Note that this function uses a scroll margin, to make some room between the sticky header and the element.
     *
     * @param {*} el              The element to scroll to
     * @param     useScrollMargin Whether or not to use scroll margin, that is; a margin between header and element when scrolling backwards to an element
     */
    function scrollTo(el, useScrollMargin = true) {
        if (typeof window.header_tools === 'undefined') {
            // console.log('Header tools undefined');
            return;
        }

        if (!el) {
            return;
        }

        const elementPosition = el.getBoundingClientRect().top;
        const scrollMarginActual = useScrollMargin ? scrollMargin : 0;

        // prettier-ignore
        const adminBarHeight = document.body.classList.contains('admin-bar') ? wordPressAdminBarHeightDesktop : 0;

        const offsetPosition =
            elementPosition +
            window.scrollY -
            window.header_tools.currentHeaderHeight -
            scrollMarginActual -
            adminBarHeight;

        window.scrollTo({
            top: offsetPosition,
            // behavior: 'smooth',
        });
    }

    /**
     * Makes all focusable children of the supplied element backwards focusable
     * when the sticky header is enabled.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} el An element
     */
    function makeBackwardsFocusable(el) {
        const children = getFocusableChildren(el);
        children.forEach((element) => {
            // Prevent adding the listener twice
            if (element.classList.contains('-backwards-focusable')) {
                return;
            }
            element.classList.add('-backwards-focusable');

            // Add listener
            element.addEventListener('focus', (e) => {
                if (!isElementVisible(e.target)) {
                    scrollTo(e.target);
                }
            });
        });
    }

    // Return an object to expose inner functions
    return {
        isElementVisible: isElementVisible,
        makeBackwardsFocusable: makeBackwardsFocusable,
        scrollTo: scrollTo,
    };
}

// Store tools in window
window.sticky_header_tools = sticky_header_tools();
